import script from "./PropetyComparablesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PropetyComparablesTab.vue?vue&type=script&setup=true&lang=js"

import "./PropetyComparablesTab.vue?vue&type=style&index=0&id=62b39d2e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62b39d2e"]])

export default __exports__